export function getPolishGenitive(number, forms) {
  if (number === void 0 || !forms || !forms.singular || !forms.plural2to4 || !forms.plural5plus) {
    return "";
  }
  const absoluteNumber = Math.abs(number);
  const lastDigit = absoluteNumber % 10;
  const lastTwoDigits = absoluteNumber % 100;
  if (lastTwoDigits >= 12 && lastTwoDigits <= 14) {
    return forms.plural5plus;
  }
  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return forms.singular;
  }
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
    return forms.plural2to4;
  }
  return forms.plural5plus;
}
